module.exports = __webpack_public_path__ + "img/gb-whatsapp-downloads.16ad5cbb.webp";